export default __webpack_public_path__ + "static/media/dashboard_nutrition_session_icon.8f421f61.svg";